export default {
	'扫一扫，微信支付':'扫一扫，微信支付',
	'金额':'金额',
	'请在':'请在',
	'分':'分',
	'秒内支付完成':'秒内支付完成',
}


// WEBPACK FOOTER //
// ./src/i18n/zh-cn/qrCode.js